import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";

import { AuthenticationService } from "app/auth/service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
  ) {}

  // canActivate
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser: any = this._authenticationService.getCurrentUser();

    if (currentUser) {
      // check if route is restricted by role
      if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
        // role not authorised so redirect to not-authorized page
        await this._router.navigate(["/pages/miscellaneous/not-authorized"]);
        return false;
      }

      const tokenIsValid: any = await this._authenticationService.tokenIsValid();
      if (!tokenIsValid) {
        localStorage.clear();
        await this._router.navigate(["/auth/login"], { queryParams: { returnUrl: state.url } });
        return false;
      }

      if (Number(currentUser.send_onboarding) === 0 && !route.routeConfig.path.includes("onboarding")) {
        await this._router.navigate(["/onboarding/masterdata"]);
        return false;
      }

      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    if (!route.routeConfig.path.includes("auth")) {
      await this._router.navigate(["/auth/login"], { queryParams: { returnUrl: state.url } });
      return false;
    }

    return true;
  }
}
